/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-25 11:48:50 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-04-25 11:55:36
 */

export default () => []